import { hash } from '@ember/helper';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import { didInsert, willDestroy } from '@ember/render-modifiers';
import type { PowerSelectBeforeOptionsSignature } from 'ember-power-select/components/power-select/before-options';
import PowerSelectBeforeOptions from 'ember-power-select/components/power-select/before-options';

import type {
  Group,
  Option,
} from '../../../types/components/prism/combo-select-input.ts';
import PrismInput from '../input.gts';

interface PrismComboSelectInputSearchSignature {
  Args: PowerSelectBeforeOptionsSignature<Option, Group<Option>>['Args'] & {
    dataA11yDialogIgnoreFocusTrap?: boolean;
  };
}

export default class PrismComboSelectInputSearch extends PowerSelectBeforeOptions<
  Option,
  Group<Option>
> {
  // Override the type signature to allow for the additional args without adapting the original signature
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get additionalArgs() {
    return this.args as PrismComboSelectInputSearchSignature['Args'];
  }

  <template>
    <div
      class="prism-combo-select-input__search"
      data-a11y-dialog-ignore-focus-trap={{this.additionalArgs.dataA11yDialogIgnoreFocusTrap}}
    >
      <PrismInput
        @autocomplete="off"
        @iconAfter={{hash name="search"}}
        @onInput={{@onInput}}
        @onKeyDown={{@onKeydown}}
        @removePadding={{true}}
        @type="search"
        @value={{@select.searchText}}
        {{didInsert this.focusInput}}
        {{willDestroy this.clearSearch}}
      />
    </div>
  </template>
}
